import type { INameTag } from '../IRenderer';

/**
 * Floating combat text label slot (plan 16 §2.3). The Pixi boot wires a pool
 * of atlas SpriteLabels here (PixiFactoriesRegistry); until then — and in
 * suites that clear it — spawnFloatingDamageText falls back to a plain name
 * tag that is destroyed on release, the pre-pool behaviour.
 */
export interface FloatingLabelStyle {
  fontSize: number;
  color: number;
  depth: number;
}

export interface FloatingLabelPool {
  acquire(x: number, y: number, text: string, style: FloatingLabelStyle): INameTag;
  release(label: INameTag): void;
}

let pool: FloatingLabelPool | null = null;

export function registerPixiFloatingLabelPool(impl: FloatingLabelPool | null): void {
  pool = impl;
}

export function getFloatingLabelPool(): FloatingLabelPool | null {
  return pool;
}
